import { Badge as ShadBadge, cn } from '@consigli/shadcn';
import { StatusVariant } from '@consigli/types';
interface BadgeProps {
  text: string;
  variant: StatusVariant;
}

export const Badge = ({ text, variant = StatusVariant.INFO }: BadgeProps) => {
  return (
    <ShadBadge
      className={cn(
        'px-2',
        variant === StatusVariant.SUCCESS &&
          'bg-green-500/20 border-1 border-green-500 text-green-800',
        variant === StatusVariant.ERROR && 'bg-red-500/20 border-1 border-red-500 text-red-800',
        variant === StatusVariant.WARNING &&
          'bg-yellow-500/20 border-1 border-yellow-500 text-yellow-800',
        variant === StatusVariant.INFO && 'bg-blue-500/20 border- border-blue-500 text-blue-800',
      )}
    >
      <p>{text}</p>
    </ShadBadge>
  );
};
